import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, IconButton, InputAdornment, Tab, Tabs, Tooltip } from '@mui/material';
import Grid from "@mui/material/Grid2"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { send_authorized_request } from '../Constants/cognito'
import { LoadingBackdropIndeterminate } from './LoadingBackdrop';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import PercentIcon from '@mui/icons-material/Percent'
import EditIcon from '@mui/icons-material/Edit';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import HelpIcon from '@mui/icons-material/Help';
import { AXIOS_API_INSTANCE, LOCATION_INTEGRATIONS_FRIENDLY_NAMES, STATE_ABBREVIATIONS } from '../Constants';
import { useSnackbar } from 'notistack';
import TabPanel from '../Utils/tabpanel';
import LocationIntegrationModal from './modals/LocationIntegrationModal';
import SelectModal from './modals/SelectModal';
import ConfirmModal from './modals/ConfirmModal';
import PhoneModal from './modals/PhoneModal';
import EmailModal from './modals/EmailModal';
import InputModal from './modals/InputModal';
import { generate_test_label, print_zebra_label_browserPrint, print_zebra_label_cloud } from "../Utils/zebra"
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useTrackedUser } from './UserState';
import InfoModal from './modals/InfoModal';
import { template_service_communication } from '../Utils/service';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const messaging_help = <React.Fragment>
    <span>Below are the template values we support:</span><br />
    <span><b>{'{{customer_name}}'}</b> Name of customer</span><br />
    <span><b>{'{{customer_phone}}'}</b> Customer Phone number</span><br />
    <span><b>{'{{customer_email}}'}</b> Customer Email address</span><br />
    <span><b>{'{{customer_address}}'}</b> Customer address</span><br />
    <span><b>{'{{customer_city}}'}</b> Customer city</span><br />
    <span><b>{'{{customer_state}}'}</b> Customer state</span><br />
    <span><b>{'{{customer_zip}}'}</b> Customer ZIP</span><br />
    <span><b>{'{{location_name}}'}</b> Your location external name</span><br />
    <span><b>{'{{service_order_number}}'}</b> Order ID# of Service Order</span><br />
    <span><b>{'{{service_order_old_status}}'}</b> Previous Service Order Status (Relevant when changing statuses)</span><br />
    <span><b>{'{{service_order_new_status}}'}</b> New Service Order Status (Relevant when changing statuses)</span><br />
    <span><b>{'{{item_manufacturer}}'}</b> Manufacturer of the customer's item</span><br />
    <span><b>{'{{item_model}}'}</b> Model of the customer's item</span><br />
    <span><b>{'{{item_identifier}}'}</b> Identifier of the customer's item</span><br />
</React.Fragment>
const message_preview_sample_so = {
    customer: {
        name: "John Doe",
        phone: "1234567890",
        email: "fakeemail@sample.com",
        address: "1234 Sample St",
        city: "Sample City",
        state: "CA",
        zip: "12345",
    },
    id: 1234,
    status_name: "SAMPLE STATUS",
    customer_item: {
        manufacturer: "Sample Manufacturer",
        model: "Sample Model",
        identifier: "Sample Identifier"
    }
}

export default function LocationPage({ location, closeFunction }) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_user,] = useTrackedUser();
    const [isLoading, setIsLoading] = React.useState(false)
    const [isTesting, setIsTesting] = React.useState(false)
    const [usersisLoading, setUsersIsLoading] = React.useState(false)
    const [tab, setTab] = React.useState((location.hash || "#details").substring(1))
    const [users, setUsers] = React.useState([])
    const [myLocation, setMyLocation] = React.useState(JSON.parse(JSON.stringify(location)))
    const [integrationModal, setIntegrationModal] = React.useState({
        open: false,
        integrationType: undefined,
        creatingNew: false
    })
    const [inputModal, setInputModal] = React.useState({
        open: false,
        callback: null,
        label: '',
        title: '',
        defaultInput: ''
    })
    const [selectModal, setSelectModal] = React.useState({
        open: false,
        callback: null,
        options: []
    })
    const [phoneModal, setPhoneModal] = React.useState({
        open: false,
        callback: null,
    })
    const [emailModal, setEmailModal] = React.useState({
        open: false,
        callback: null,
    })
    const [confirmModal, setConfirmModal] = React.useState({
        open: false,
        text: '',
        callback: null
    })
    const [infoModal, setInfoModal] = React.useState({ open: false, title: '', content: '' })
    const all_integrations = myLocation?.integrations
    const sampleTextUrl = `https://api.profitmaxprosuite.com/${my_user.client.id}/s/aaaabbbb`

    const handleChange = (prop) => (event) => {
        if (["allow_cash"].includes(prop)) {
            setMyLocation({ ...myLocation, [prop]: event.target.checked })
        } else if (['zip'].includes(prop)) {
            if (/^\d{0,5}(-\d{0,4})?$/.test(event.target.value)) {
                setMyLocation({ ...myLocation, [prop]: event.target.value })
            }
        } else {
            setMyLocation({ ...myLocation, [prop]: event.target.value })
        }
    }
    const handleUserChange = (e, options, action, option) => {
        if (action === "removeOption") {
            myLocation.users = myLocation.users.filter((item) => item.id !== option.option.id)
            myLocation.user_ids = myLocation.user_ids.filter((item) => item !== option.option.id)
        } else {
            myLocation.users.push(option.option)
            myLocation.user_ids.push(option.option.id)
        }
        setMyLocation({ ...myLocation })
    }

    const message_preview = (message) => {
        const newData = {
            title: "Preview",
            content: template_service_communication(myLocation, message_preview_sample_so, message, 'SAMPLE NEW STATUS'),
            maxWidth: "md",
            level: "info",
        }
        setInfoModal({
            open: true,
            ...newData,
            callback: () => { setInfoModal({ open: false, ...newData }) },
        })
    }

    const save = (event) => {
        setIsLoading(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(
                `locations/${myLocation.id}`,
                myLocation
            ).then(() => {
                enqueueSnackbar('Successfully updated location', { variant: 'success' })
                setIsLoading(false)
                closeFunction(true)
            }).catch((error) => {
                setIsLoading(false)
                enqueueSnackbar(`Failed to update location <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    const addIntegration = () => {
        setIntegrationModal({
            ...integrationModal,
            open: true,
            creatingNew: true,
        })
    }

    const testIntegration = (integration) => {
        if (integration === "BLOCKCHYP") {
            setSelectModal({
                ...selectModal,
                open: true,
                title: 'Select Terminal',
                options: all_integrations[integration].TERMINAL_NAMES,
                defaultOption: "",
                closeModal: (selection) => {
                    if (selection) {
                        setIsTesting(true)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.post(
                                `locations/${myLocation.id}/integrations/test`,
                                { integration: integration, terminal: selection }
                            ).then(() => {
                                enqueueSnackbar('Successfully tested BLOCKCHYP integration', { variant: 'success', autoHideDuration: 5000 })
                                setIsTesting(false)
                            }).catch((error) => {
                                setIsTesting(false)
                                enqueueSnackbar(`BLOCKCHYP integration test failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error', autoHideDuration: 10000 })
                            })
                        )
                    }
                    setSelectModal({ ...selectModal, open: false })
                }
            })
        } else if (integration === "TWILIO") {
            setPhoneModal({
                ...phoneModal,
                open: true,
                title: 'Send Test Message To',
                closeModal: (phone) => {
                    if (phone) {
                        setIsTesting(true)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.post(
                                `locations/${myLocation.id}/integrations/test`,
                                { integration: integration, phone: phone }
                            ).then(() => {
                                enqueueSnackbar('Successfully tested TWILIO integration', { variant: 'success', autoHideDuration: 5000 })
                                setIsTesting(false)
                            }).catch((error) => {
                                setIsTesting(false)
                                enqueueSnackbar(`TWILIO integration test failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error', autoHideDuration: 10000 })
                            })
                        )
                    }
                    setPhoneModal({ ...phoneModal, open: false })
                }
            })
        } else if (integration === "MAILGUN") {
            setEmailModal({
                ...emailModal,
                open: true,
                title: 'Send Test Message To',
                closeModal: (email) => {
                    if (email) {
                        setIsTesting(true)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.post(
                                `locations/${myLocation.id}/integrations/test`,
                                { integration: integration, email: email }
                            ).then(() => {
                                enqueueSnackbar('Successfully tested MAILGUN integration', { variant: 'success', autoHideDuration: 5000 })
                                setIsTesting(false)
                            }).catch((error) => {
                                setIsTesting(false)
                                enqueueSnackbar(`MAILGUN integration test failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error', autoHideDuration: 10000 })
                            })
                        )
                    }
                    setEmailModal({ ...emailModal, open: false })
                }
            })
        } else if (integration === "ZEBRA_PRINTER_LOCAL") {
            setIsTesting(true)
            print_zebra_label_browserPrint(generate_test_label(), undefined, myLocation.id, undefined,
                (error) => {
                    console.log(error)
                    enqueueSnackbar(`Zebra Printer Local integration test failed <${error}>`, { variant: 'error', autoHideDuration: 10000 })
                    setIsTesting(false)
                }, true)
        } else if (integration === "ZEBRA_PRINTER_CLOUD") {
            setSelectModal({
                ...selectModal,
                open: true,
                title: 'Select Printer',
                options: (all_integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS ?? []).map((x) => `${x[0]}`),
                defaultOption: "",
                closeModal: (selection) => {
                    if (selection) {
                        setIsTesting(true)
                        print_zebra_label_cloud(generate_test_label(),
                            (all_integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS ?? []).find((x) => x[0] === selection)[1],
                            myLocation.id,
                            () => {
                                setIsTesting(false)
                                enqueueSnackbar(`Successfully tested Zebra Printer Cloud Integration`, { variant: 'success', autoHideDuration: 5000 })
                            },
                            (error) => {
                                console.log(error)
                                setIsTesting(false)
                                enqueueSnackbar(`Zebra Printer Cloud Integration test failed: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error', autoHideDuration: 10000 })
                            })
                    }
                    setSelectModal({ ...selectModal, open: false })
                }
            })
        } else if (integration === "PALADIN") {
            setInputModal({
                ...inputModal,
                open: true,
                title: 'Paladin Part Number to Query',
                label: 'Part Number',
                defaultInput: '',
                callback: (results, part_number) => {
                    if (results) {
                        setIsTesting(true)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.post(
                                `locations/${myLocation.id}/integrations/test`,
                                { integration: integration, part_number: part_number }
                            ).then(() => {
                                enqueueSnackbar('Successfully tested Paladin integration', { variant: 'success', autoHideDuration: 5000 })
                                setIsTesting(false)
                            }).catch((error) => {
                                setIsTesting(false)
                                enqueueSnackbar(`Paladin integration test failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error', autoHideDuration: 10000 })
                            })
                        )
                    }
                    setInputModal({ ...inputModal, open: false })
                }
            })
        }


    }

    const editIntegration = (integration) => {
        setIntegrationModal({
            ...integrationModal,
            open: true,
            creatingNew: false,
            integrationType: integration
        })
    }

    const deleteIntegration = (integration) => {
        setConfirmModal({
            open: true,
            text: `Are you sure you want to delete the ${integration} integration?`,
            callback: (confirmation) => {
                if (confirmation) {
                    setIsLoading(true)
                    send_authorized_request(() =>
                        AXIOS_API_INSTANCE.post(
                            `locations/${myLocation.id}/integrations/delete`,
                            { integration: integration }
                        ).then((response) => {
                            enqueueSnackbar(`Successfully deleted ${integration} integration`, { variant: 'success' })
                            setIsLoading(false)
                            setMyLocation(response.data.data)
                        }).catch((error) => {
                            setIsLoading(false)
                            enqueueSnackbar(`Deleting ${integration} integration failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                        })
                    )
                }
                setConfirmModal({ ...confirmModal, open: false, text: `Are you sure you want to delete the ${integration} integration?` })
            }
        })
    }

    React.useEffect(() => {
        setUsersIsLoading(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get(`users`).then(
                (users) => {
                    setUsers(users.data.data)
                    setUsersIsLoading(false)
                }
            ).catch((error) => {
                setUsersIsLoading(false)
                enqueueSnackbar(`Failed to get users <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={isLoading}
                text={"Saving Location"}
            />
            <LoadingBackdropIndeterminate
                open={isTesting}
                text={"Testing"}
            />
            {myLocation.id !== undefined &&
                <Box sx={{ pl: 1, pr: 1 }}>
                    <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                        <Grid size="grow">
                            <h2>EDITING LOCATION</h2>
                        </Grid>
                        <Grid size="auto">
                            <IconButton onClick={() => closeFunction(true)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Tabs
                        orientation="horizontal"
                        variant="scrollable"
                        value={tab}
                        onChange={(e, value) => setTab(value)}
                        aria-label="tabs"
                    >
                        <Tab label="Details" value="details" />
                        <Tab label="Integrations" value="integrations" />
                        <Tab label="Service Configurations" value="service_configs" />
                    </Tabs>
                    <TabPanel value={tab} value_key={"details"} sx={{ p: 0 }}>
                        <Grid container columnSpacing={2} columns={{ xs: 6, sm: 6, md: 12 }}>
                            <Grid size={6} container direction="column" justifyContent={'flex-start'}>
                                <Grid>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Name"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.name}
                                        onChange={handleChange("name")}
                                    />
                                </Grid>
                                <Grid>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="external_name"
                                        label="Customer Facing Name"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.external_name}
                                        onChange={handleChange("external_name")}
                                    />
                                </Grid>
                                <Grid>
                                    <TextField
                                        margin="dense"
                                        id="email"
                                        label="Email"
                                        type="email"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.email}
                                        onChange={handleChange("email")}
                                    />
                                </Grid>
                                <Grid>
                                    <TextField
                                        margin="dense"
                                        id="phone"
                                        label="Phone"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.phone}
                                        onChange={handleChange("phone")}
                                    />
                                </Grid>
                                <Grid>
                                    <Tooltip
                                        title="Allow cash transactions at this location?"
                                        arrow
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={myLocation.allow_cash || false}
                                                    onChange={handleChange("allow_cash")}
                                                />
                                            }
                                            label="Allow Cash Transactions"
                                        />
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Grid size={6} container direction="column">
                                <Grid>
                                    <TextField
                                        margin="dense"
                                        id="address_1"
                                        label="Address 1"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.address_1}
                                        onChange={handleChange("address_1")}
                                    />
                                </Grid>
                                <Grid>
                                    <TextField
                                        margin="dense"
                                        id="address_2"
                                        label="Address 2"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.address_2}
                                        onChange={handleChange("address_2")}
                                    />
                                </Grid>
                                <Grid>
                                    <Grid container spacing={1}>
                                        <Grid size={5}>
                                            <TextField
                                                margin="dense"
                                                id="city"
                                                label="City"
                                                type="text"
                                                fullWidth
                                                variant="filled"
                                                value={myLocation.city}
                                                onChange={handleChange("city")}
                                            />
                                        </Grid>
                                        <Grid size={"auto"}>
                                            <FormControl variant="filled" sx={{ mt: 1, minWidth: 80 }}>
                                                <Autocomplete
                                                    options={STATE_ABBREVIATIONS}
                                                    isOptionEqualToValue={(option, value) => option === value}
                                                    autoComplete
                                                    includeInputInList
                                                    disableClearable
                                                    value={myLocation?.state ?? ''}
                                                    onChange={(e, val) => setMyLocation({ ...myLocation, state: val })}
                                                    renderInput={(params) => {
                                                        return (<TextField {...params} label="State" variant="filled" fullWidth autoComplete='off' />)
                                                    }}
                                                    renderOption={(props, option, { inputValue }) => {
                                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                                        const parts = parse(props.key, matches);
                                                        props.key = props.id

                                                        return (
                                                            <li {...props} >
                                                                <div>
                                                                    {parts.map((part, index) => (
                                                                        <span
                                                                            key={index}
                                                                            style={{
                                                                                fontWeight: part.highlight ? 700 : 400,
                                                                            }}
                                                                        >
                                                                            {part.text}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </li>
                                                        );
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid size={"grow"}>
                                            <TextField
                                                margin="dense"
                                                id="zip"
                                                label="ZIP / Postal"
                                                type="number"
                                                inputMode="numeric"
                                                fullWidth
                                                variant="filled"
                                                value={myLocation.zip}
                                                onChange={handleChange("zip")}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <TextField
                                        margin="dense"
                                        id="tax_rate"
                                        label="Tax Rate"
                                        type="number"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation.tax_rate}
                                        onChange={handleChange("tax_rate")}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PercentIcon />
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid sx={{ pt: 1 }}>
                                    <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        disableClearable
                                        sx={{ width: '100%', maxWidth: '100%' }}
                                        onChange={handleUserChange}
                                        getOptionLabel={(option) => `${option.name}` || ""}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        value={myLocation.users.sort((a, b) => a.name.localeCompare(b.name))}
                                        options={users}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                    value={option.id}
                                                />
                                                {`${option.name} (${option.email})`}
                                            </li>
                                        )}
                                        loading={usersisLoading}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                label="Users"
                                                placeholder={myLocation.users?.length > 0 ? '' : "Location's Users"}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={10} sx={{ pt: 2 }} justifyContent={'flex-end'}>
                            <Grid justifyContent={'flex-end'} size='auto'>
                                <Button variant='contained' onClick={() => save()} sx={{ mr: 1 }}>
                                    <SaveIcon /> <Box sx={{ pl: 1 }}><span>Save</span></Box>
                                </Button>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={tab} value_key={"integrations"} sx={{ p: 0, mt: 1 }}>
                        <Button variant="contained" color='primary' onClick={addIntegration}>Add Integration</Button>
                        {
                            Object.keys(all_integrations).sort().map((integration) => {
                                if (integration === 'BLOCKCHYP') {
                                    return (
                                        (<Box key={integration} sx={{ border: 1, m: 1, p: 1, position: 'relative' }}>
                                            <Grid container>
                                                <Grid size="auto">
                                                    <b><span>{LOCATION_INTEGRATIONS_FRIENDLY_NAMES[integration]}</span></b>
                                                </Grid>
                                                <Grid size="grow"></Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('BLOCKCHYP')} sx={{ color: 'orange' }}>Test</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => editIntegration('BLOCKCHYP')} sx={{ color: 'orange' }}>Edit <EditIcon /></Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => deleteIntegration('BLOCKCHYP')} sx={{ color: 'red' }}>Delete <DeleteIcon /></Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid container direction={'column'} size="auto">
                                                    <Grid size="grow">
                                                        <span>API Key:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Test Mode:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Allow Emailed Payment Links:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Terminals:</span>
                                                    </Grid>
                                                </Grid>
                                                <Grid container direction={'column'} size="grow">
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].BLOCKCHYP_API_KEY}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].TEST ? 'Yes' : 'No'}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].ALLOW_EMAIL ? 'Yes' : 'No'}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].TERMINAL_NAMES.join(", ")}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>)
                                    );
                                } else if (integration === 'TWILIO') {
                                    return (
                                        (<Box key={integration} sx={{ border: 1, m: 1, p: 1, position: 'relative' }}>
                                            <Grid container>
                                                <Grid size="auto">
                                                    <b><span>{LOCATION_INTEGRATIONS_FRIENDLY_NAMES[integration]}</span></b>
                                                </Grid>
                                                <Grid size="grow"></Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('TWILIO')} sx={{ color: 'orange' }}>Test</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => editIntegration('TWILIO')} sx={{ color: 'orange' }}>Edit <EditIcon /></Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => deleteIntegration('TWILIO')} sx={{ color: 'red' }}>Delete <DeleteIcon /></Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid container direction={'column'} size="auto">
                                                    <Grid size="grow">
                                                        <span>Account SID:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>FROM Phone Number:</span>
                                                    </Grid>
                                                </Grid>
                                                <Grid container direction={'column'} size="grow">
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].TWILIO_ACCOUNT_SID}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].TWILIO_FROM_PHONE_NUMBER}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>)
                                    );
                                } else if (integration === 'MAILGUN') {
                                    return (
                                        (<Box key={integration} sx={{ border: 1, m: 1, p: 1, position: 'relative' }}>
                                            <Grid container>
                                                <Grid size="auto">
                                                    <b><span>{LOCATION_INTEGRATIONS_FRIENDLY_NAMES[integration]}</span></b>
                                                </Grid>
                                                <Grid size="grow"></Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('MAILGUN')} sx={{ color: 'orange' }}>Test</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => editIntegration('MAILGUN')} sx={{ color: 'orange' }}>Edit <EditIcon /></Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => deleteIntegration('MAILGUN')} sx={{ color: 'red' }}>Delete <DeleteIcon /></Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid container direction={'column'} size="auto">
                                                    <Grid size="grow">
                                                        <span>Domain:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>FROM Email:</span>
                                                    </Grid>
                                                </Grid>
                                                <Grid container direction={'column'} size="grow">
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].MAILGUN_DOMAIN_NAME}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].MAILGUN_FROM_EMAIL}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>)
                                    );
                                } else if (integration === 'ZEBRA_PRINTER') {
                                    return (
                                        (<Box key={integration} sx={{ border: 1, m: 1, p: 1, position: 'relative' }}>
                                            <Grid container>
                                                <Grid size="auto">
                                                    <b><span>{LOCATION_INTEGRATIONS_FRIENDLY_NAMES[integration]}</span></b>
                                                </Grid>
                                                <Grid size="grow"></Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('ZEBRA_PRINTER_LOCAL')} sx={{ color: 'orange' }}>Test Local</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('ZEBRA_PRINTER_CLOUD')} sx={{ color: 'orange' }}>Test Cloud</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => editIntegration('ZEBRA_PRINTER')} sx={{ color: 'orange' }}>Edit <EditIcon /></Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => deleteIntegration('ZEBRA_PRINTER')} sx={{ color: 'red' }}>Delete <DeleteIcon /></Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid container direction={'column'} size="auto">
                                                    <Grid size="grow">
                                                        <span>Tenant:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Printers:</span>
                                                    </Grid>
                                                </Grid>
                                                <Grid container direction={'column'} size="grow">
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].ZEBRA_TENANT}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{(all_integrations[integration].ZEBRA_PRINTERS ?? []).map((x) => `${x[0]} (${x[1]})`).join(", ")}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>)
                                    );
                                } else if (integration === 'PALADIN') {
                                    return (
                                        (<Box key={integration} sx={{ border: 1, m: 1, p: 1, position: 'relative' }}>
                                            <Grid container>
                                                <Grid size="auto">
                                                    <b><span>{LOCATION_INTEGRATIONS_FRIENDLY_NAMES[integration]}</span></b>
                                                </Grid>
                                                <Grid size="grow"></Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => testIntegration('PALADIN')} sx={{ color: 'orange' }}>Test</Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => editIntegration('PALADIN')} sx={{ color: 'orange' }}>Edit <EditIcon /></Button>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button onClick={() => deleteIntegration('PALADIN')} sx={{ color: 'red' }}>Delete <DeleteIcon /></Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid container direction={'column'} size="auto">
                                                    <Grid size="grow">
                                                        <span>Username:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Store ID:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Default Service SKU:</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>Service Deposit SKU:</span>
                                                    </Grid>
                                                </Grid>
                                                <Grid container direction={'column'} size="grow">
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].PALADIN_USERNAME}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].PALADIN_STORE_ID}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].PALADIN_DEFAULT_SERVICE_SKU}</span>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <span>{all_integrations[integration].PALADIN_SERVICE_DEPOSIT_SKU}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>)
                                    );
                                } else {
                                    return undefined
                                }
                            })
                        }
                    </TabPanel>
                    <TabPanel value={tab} value_key={"service_configs"} sx={{ p: 0, mt: 1 }}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <b><span>Shop Fees</span></b>
                            </Grid>
                            <Grid container size="auto" spacing={1} alignItems={'center'}>
                                <Grid size="auto">
                                    <Tooltip
                                        title="Set a minimum shop fee?"
                                        arrow
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={myLocation.service_fees?.shop_fee_minimum !== undefined}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}), shop_fee_minimum: location?.service_fees?.shop_fee_minimum ?? 0 } })
                                                        } else {
                                                            delete myLocation.service_fees.shop_fee_minimum
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}) } })
                                                        }
                                                    }}
                                                />
                                            }
                                            label="Minimum"
                                        />
                                    </Tooltip>
                                </Grid>
                                <Grid size="auto">
                                    <TextField
                                        margin="dense"
                                        id="shop_fee_minimum"
                                        label="Minimum"
                                        type="number"
                                        fullWidth
                                        variant="filled"
                                        disabled={myLocation.service_fees?.shop_fee_minimum === undefined}
                                        value={myLocation?.service_fees?.shop_fee_minimum ?? 0}
                                        onChange={(e) => {
                                            const val = Math.max(0, Math.min(parseFloat(e.target.value), myLocation?.service_fees?.shop_fee_maximum ?? Infinity))
                                            setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, shop_fee_minimum: val } })
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AttachMoneyIcon />
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container size="auto" spacing={1} alignItems={'center'}>
                                <Grid size="auto">
                                    <Tooltip
                                        title="Set a maximum shop fee?"
                                        arrow
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={myLocation.service_fees?.shop_fee_maximum !== undefined}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            const val = Math.max(myLocation?.service_fees?.shop_fee_minimum ?? 0, myLocation?.service_fees?.shop_fee_maximum ?? 0)
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}), shop_fee_maximum: val } })
                                                        } else {
                                                            delete myLocation.service_fees.shop_fee_maximum
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}) } })
                                                        }
                                                    }}
                                                />
                                            }
                                            label="Maximum"
                                        />
                                    </Tooltip>
                                </Grid>
                                <Grid size="auto">
                                    <TextField
                                        margin="dense"
                                        id="shop_fee_maximum"
                                        label="Maximum"
                                        type="number"
                                        fullWidth
                                        variant="filled"
                                        disabled={myLocation.service_fees?.shop_fee_maximum === undefined}
                                        value={myLocation?.service_fees?.shop_fee_maximum ?? ''}
                                        onChange={(e) => {
                                            const val = Math.max(0, parseFloat(e.target.value), myLocation?.service_fees?.shop_fee_minimum ?? 0)
                                            setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, shop_fee_maximum: val } })
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AttachMoneyIcon />
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container size={12} alignItems={'center'}>
                                <Grid size="auto">
                                    <TextField
                                        margin="dense"
                                        id="shop_fee_percentage"
                                        label="Percentage Rate"
                                        type="number"
                                        fullWidth
                                        variant="filled"
                                        value={myLocation?.service_fees?.shop_fee_percentage ?? 0}
                                        onChange={(e) => {
                                            const val = parseFloat(Math.max(0, e.target.value))
                                            setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, shop_fee_percentage: val } })
                                        }}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PercentIcon />
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid container size="auto" direction={'column'}>
                                    <Grid size="auto">
                                        <Tooltip
                                            title="Include percentage of Service Flat Rate and Hourly Rate costs?"
                                            arrow
                                            placement='right'
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={myLocation.service_fees?.shop_fee_include_service ?? false}
                                                        onChange={(e) => {
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}), shop_fee_include_service: e.target.checked } })
                                                        }}
                                                    />
                                                }
                                                label="Service"
                                            />
                                        </Tooltip>
                                    </Grid>
                                    <Grid size="auto">
                                        <Tooltip
                                            title="Include percentage of Service Part costs?"
                                            arrow
                                            placement='right'
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={myLocation.service_fees?.shop_fee_include_parts ?? false}
                                                        onChange={(e) => {
                                                            setMyLocation({ ...myLocation, service_fees: { ...(myLocation.service_fees ?? {}), shop_fee_include_parts: e.target.checked } })
                                                        }}
                                                    />
                                                }
                                                label="Parts"
                                            />
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container size={12} alignItems={'center'}>
                                <Grid size="auto">
                                    <TextField
                                        margin="dense"
                                        id="shop_fee_sku"
                                        label="Shop Fees SKU"
                                        type="text"
                                        variant="filled"
                                        value={myLocation.service_fees?.shop_fee_sku ?? ''}
                                        onChange={(e) => setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, shop_fee_sku: e.target.value } })}
                                    />
                                </Grid>
                                <Grid size="auto">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={myLocation.service_fees?.shop_fee_taxable || false}
                                                onChange={(e) => setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, shop_fee_taxable: e.target.checked } })}
                                            />
                                        }
                                        label="Taxable"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container size={12} alignItems={'center'}>
                                <Grid size="auto">
                                    <TextField
                                        margin="dense"
                                        id="adjustment_sku"
                                        label="Default Adjustment SKU"
                                        type="text"
                                        variant="filled"
                                        value={myLocation.service_fees?.adjustment_sku ?? ''}
                                        onChange={(e) => setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, adjustment_sku: e.target.value } })}
                                    />
                                </Grid>
                                <Grid size="auto">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={myLocation.service_fees?.adjustment_taxable || false}
                                                onChange={(e) => setMyLocation({ ...myLocation, service_fees: { ...myLocation.service_fees, adjustment_taxable: e.target.checked } })}
                                            />
                                        }
                                        label="Taxable"
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <span><b>Default Messaging</b></span>
                                <IconButton onClick={() => {
                                    const newData = {
                                        title: "Message Templating",
                                        content: messaging_help,
                                        maxWidth: "md",
                                        level: "help",
                                    }
                                    setInfoModal({
                                        open: true,
                                        ...newData,
                                        callback: () => { setInfoModal({ open: false, ...newData }) },
                                    })
                                }}>
                                    <HelpIcon />
                                </IconButton>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    margin="dense"
                                    id="quotetextmessage"
                                    label="Quote Text Message"
                                    type="text"
                                    variant="filled"
                                    value={myLocation.service_configs?.quote_text ?? ''}
                                    onChange={(e) => setMyLocation({ ...myLocation, service_configs: { ...myLocation.service_configs, quote_text: e.target.value } })}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    helperText={`Link will be added to the end of the message. ${(myLocation.service_configs?.quote_text ?? '').trim().length + 1 + sampleTextUrl.length}/765`}
                                />
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button variant="contained" onClick={() => message_preview(myLocation.service_configs?.quote_text ?? '')}>
                                        Preview
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    margin="dense"
                                    id="quoteemailmessage"
                                    label="Quote Email Message"
                                    type="text"
                                    variant="filled"
                                    value={myLocation.service_configs?.quote_email ?? ''}
                                    onChange={(e) => setMyLocation({ ...myLocation, service_configs: { ...myLocation.service_configs, quote_email: e.target.value } })}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                />
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button variant="contained" onClick={() => message_preview(myLocation.service_configs?.quote_email ?? '')}>
                                        Preview
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    margin="dense"
                                    id="invoicetextmessage"
                                    label="Invoice Text Message"
                                    type="text"
                                    variant="filled"
                                    value={myLocation.service_configs?.invoice_text ?? ''}
                                    onChange={(e) => setMyLocation({ ...myLocation, service_configs: { ...myLocation.service_configs, invoice_text: e.target.value } })}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    helperText={`Link will be added to the end of the message. ${(myLocation.service_configs?.invoice_text ?? '').trim().length + 1 + sampleTextUrl.length}/765`}
                                />
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button variant="contained" onClick={() => message_preview(myLocation.service_configs?.invoice_text ?? '')}>
                                        Preview
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    margin="dense"
                                    id="invoiceemailmessage"
                                    label="Invoice Email Message"
                                    type="text"
                                    variant="filled"
                                    value={myLocation.service_configs?.invoice_email ?? ''}
                                    onChange={(e) => setMyLocation({ ...myLocation, service_configs: { ...myLocation.service_configs, invoice_email: e.target.value } })}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                />
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button variant="contained" onClick={() => message_preview(myLocation.service_configs?.invoice_email ?? '')}>
                                        Preview
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </TabPanel>
                </Box>
            }
            <LocationIntegrationModal
                location={myLocation}
                closeModal={(results) => {
                    if (results) {
                        setMyLocation(results.data.data)
                    }
                    setIntegrationModal({ ...integrationModal, open: false })
                }}
                {...integrationModal}
            />
            <InputModal
                {...inputModal}
            />
            <SelectModal
                {...selectModal}
            />
            <PhoneModal
                {...phoneModal}
            />
            <EmailModal
                {...emailModal}
            />
            <ConfirmModal
                {...confirmModal}
            />
            <InfoModal
                {...infoModal}
            />
        </React.Fragment >)
    );
}